import { Pipe, PipeTransform } from '@angular/core';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';

@Pipe({
  name: 'newAnnouncementsModalFilter'
})
export class NewAnnouncementsModalFilterPipe implements PipeTransform {

  transform(siteAnnouncement: TylerMatTableDataSource[], school: string): any {
    const sitedata = new TylerMatTableDataSource();
    const site = siteAnnouncement[0].data.filter(x => x.SchoolName == school);
    sitedata[0] = new TylerMatTableDataSource(site);
    return sitedata[0];
  }

}
